export default __webpack_public_path__ + "static/media/44.8044ce0f.png";